
import { Component, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import {
  IDefaultShippingOrderModel,
  ITypeModel,
} from "@/api/types";
import { OrderManagement } from "./types";
import Pagination from "@/components/Pagination/index.vue";
import {
  auditHold,
  auditCancelHold,
  auditPass,
  getConversionExchangeRate,
  getDraftPriceType,
  getRecordsStatus,
  getSuppliersList,
} from "@/api/inquiry";
import {
  getPurchaseOrderList,
  invalidPurchaseOrder,
  deleteShippingMarks,
  putRemark,
  getPiInfo,
  uploadInfoFile,
  getPiList, updatePoBrand,
} from "@/api/proforma";
import { poShippingRemark } from "@/api/purchase-order";
import { COMPANY_OPTIONS } from "@/constant";
import { deepClone } from "@/utils/deepClone";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import {
  downloadTemplate,
  downloadTemplateExcel,
  putCancelInvalid,
  updatePackingState,
  markException,
  markNormal
} from "@/api/purchase-order";
import AssignMarks from "@/views-oms/sales-order-management/order/order-management/components/assign-marks/index.vue";
import {findBrandByKeyword} from "@/api/brand";
import checkPermission from "@/utils/permission_btn";
import { UserModule } from "@/store/modules/user";
import { formatPrice } from "@/utils/number";
import {ShippingOrderModel} from "@/model/shipping-order";
import {purchaseOrderMatch, savePurchaseOrderShellPackages} from "@/api/shell-package";
import PoOtherFee from "@/views-oms/sales-order-management/order/order-management/components/po-other-fee/index.vue";

@Component({
  name: "quotationDetails",
  components: {
    PoOtherFee,
    AssignMarks,
    Pagination,
    MatchingShellPackaging: () =>
      import("./components/matching-shell-packaging/index.vue"),
    FileManagement: () => import("./components/file-management/index.vue"),
    CheckReceipt: () => import("./components/check-receipt/index.vue"),
    DeliverySchedule: () => import("./components/delivery-schedule/index.vue"),
    Marks: () => import("./components/marks/index.vue"),
  },
})
export default class extends Vue {
  // 是否显示所有产品号码
  private isShowMore = false;
  private showPiSheet = false;
  private tableHeight = 420;
  private layoutObserver: { observe: (target: Element) => void; disconnect: () => void } | null = null;
  private onWindowResize = () => this.updateTableHeight();
  private isShowMore2 = false;
  private isShowMore3 = false;
  private showMatching = false;
  private showFile = false;
  private showReceipt = false;
  private showList = false;
  private showMarks = false;
  private showRemarks = false;
  private showOtherFees = false;
  private showRowRemark = false;
  private remark = "";
  private rowRemark = "";
  private rowRemarkLength = 255;
  private rowRemarkRow: any = null;
  private rowRemarkClick = "handleRemark";
  private brandOptions: any[] = [];
  private brandTipText = "";
  private changeIcon = require("@/assets/images/ic_biangeng.png");
  private sampleIcon = require("@/assets/images/ic_include_sample.png");
  private tableKey = 0;
  private companyCodeOptions = COMPANY_OPTIONS;
  private containerTypeOptionsList: ITypeModel[] = [];
  public shippingOrder: IDefaultShippingOrderModel[] = [];
  private total = 0;
  private listLoading = true;
  private selectedRow: ShippingOrderModel = new ShippingOrderModel();

  private conversionExchangeRate = 0;
  private id = "";

  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as OrderManagement[],
  };
  private listParam = {
    approvalRecordId: null,
    inquirySheetId: null,
    refNumber: null,
    refTypeId: null,
    quotedStatus: null,
    orderStatus: null,
    supplier: null,
    hqProductName: null,
    productName: null,
    type: null,
  };
  public searchForm = [
    {
      label: "供应商",
      prop: "supplier",
      key: "supplier",
      type: "select",
      value: "",
      placeholder: "",
      remote_method: this.getSuppliersList,
      remote: true,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      type: "input",
      value: "",
      placeholder: "请输入华强品名",
    },
    {
      label: "下单时间",
      prop: "time",
      key: "time",
      type: "datePicker",
      value: "",
    },
  ];
  public tableCol = [
    {
      label: "S/N",
      key: "sn",
    },
    {
      label: "采购订单号",
      key: "code",
    },
    {
      label: "华强品名",
      key: "hqProductName",
    },
    {
      label: "供应商简称",
      key: "supplierAbbreviation",
    },
    {
      label: "采购员",
      key: "purchase",
    },
    {
      label: "交易状态",
      key: "shippingStatus",
    },
    {
      label: "下单状态",
      key: "orderState",
    },
    {
      label: "审核",
      key: "reviewStatus",
    },
    {
      label: "收到数量",
      key: "actualQuantity",
    },
    {
      label: "下单数量",
      key: "orderQuantity",
    },
    {
      label: "PI号码",
      key: "piCode",
    },
    {
      label: "PO号码",
      key: "poNumber",
    },
    {
      label: "批次号",
      key: "batchNumber",
    },
    {
      label: "下单金额",
      key: "orderAmount",
    },
    {
      label: "订单费用",
      key: "otherFee",
    },
    // {
    //   label: "实交后数量",
    //   key: "actualQuantity",
    // },
    // {
    //   label: "实交后金额",
    //   key: "actualAmount",
    // },
    {
      label: "约定交期",
      key: "contractualDeliveryDate",
    },
    // {
    //   label: "最后修改时间",
    //   key: "updatedTime",
    // },
    // {
    //   label: "收到/下单数量",
    //   key: "deliveryProgress",
    // },
    // {
    //   label: "入库数量",
    //   key: "goodsEnteredQuantity",
    // },
    // {
    //   label: "报关计划",
    //   key: "declarationPlanQuantity",
    // },
    // {
    //   label: "发货报关进度",
    //   key: "declarationProgress",
    // },
    // {
    //   label: "数量变动",
    //   key: "quantityChange",
    // },
    {
      label: "壳体",
      key: "shellPackages",
    },
    {
      label: "品牌",
      key: "brand",
    },
    {
      label: "订单拆分",
      key: "purchaseOrderGroup",
    },
    {
      label: "唛头",
      key: "shippingMark",
    },
    {
      label: "出货备注",
      key: "shippingRemark",
    },
    {
      label: "备注",
      key: "remark",
    },
  ] as any;
  public customerInfo = {} as any;
  public selectedItem = {} as any;
  public customerStatus = "";
  public customerInfoFields = [
    {
      label: "长期定金",
      key: "longTermDeposit",
    },
    {
      label: "PI生成时间",
      key: "createdTime",
      type: "date",
    },
    {
      label: "下单时间",
      key: "orderPlacementTime",
      type: "date",
    },
    {
      label: "备注",
      key: "remark",
    },
  ] as any;
  private currentRow = {};

  get billWho() {
    return [this.customerInfo.customerAbbr, this.customerInfo.customerNation, this.customerInfo.company]
      .filter((item) => item)
      .join("  ·  ");
  }

  get sheetFields() {
    return this.customerInfoFields.filter((item) => this.canSeeAccount(item.account));
  }

  get piMarks() {
    return Array.isArray(this.customerInfo.mark) ? this.customerInfo.mark : [];
  }

  get headerStats() {
    const info = this.customerInfo || {};
    const stats: { label: string; value: any; price?: boolean }[] = [
      { label: "接单", value: info.shipmentQuantity },
      { label: "下单", value: info.deliveryQuantity },
    ];
    if (this.canSeeAccount(["A", "A_B"])) {
      stats.push({ label: "PI金额", value: info.shipmentAmount, price: true });
    }
    if (this.canSeeAccount(["B", "A_B"])) {
      stats.push({ label: "销售总定价", value: info.companyAmount, price: true });
    }
    stats.push({ label: "下单金额", value: info.deliveryAmount, price: true });
    return stats;
  }

  get showPI() {
    return this.customerStatus === "审批通过";
  }

  get showHold() {
    return this.customerStatus === "待审核";
  }

  get showCancelHold() {
    return this.customerStatus === "已挂起";
  }

  get showPass() {
    return "待审核,已挂起".indexOf(this.customerStatus) > -1 ? true : false;
  }

  created() {
    this.id = this.$route.query.id as string;
    // this.getHeaderInfo(this.$route.query.code);
    // this.customerInfo =  this.$route.query.item && JSON.parse(this.$route.query.item as string);
    this.init();
  }

  activated() {
    this.getHeaderInfo(this.$route.query.code);
    this.init();
    this.updateTableHeight();
  }

  mounted() {
    const head = this.$refs.deskHead as HTMLElement | undefined;
    const pane = this.$refs.tablePane as HTMLElement | undefined;
    const Observer = (window as any).ResizeObserver;
    if ((head || pane) && typeof Observer === "function") {
      const observer = new Observer(() => this.updateTableHeight());
      if (head) observer.observe(head);
      if (pane) observer.observe(pane);
      this.layoutObserver = observer;
    }
    window.addEventListener("resize", this.onWindowResize);
    this.updateTableHeight();
  }

  beforeDestroy() {
    if (this.layoutObserver) {
      this.layoutObserver.disconnect();
      this.layoutObserver = null;
    }
    window.removeEventListener("resize", this.onWindowResize);
  }

  private init() {
    this.getPiInfo();
    this.getConversionExchangeRate();
    this.getList();
  }

  private async downloadTemplate(row) {
    await downloadTemplate(row.row.id);
  }

  private async downloadTemplateExcel(row) {
    await downloadTemplateExcel(row.row.id);
  }

  private async getHeaderInfo(code) {
    const params = {
      code: code,
      pageNumber: 1,
      pageSize: 1,
    };
    this.listLoading = false;
    const { list }: any = await getPiList(params);
    if (list.length > 0) {
      this.customerInfo = list[0];
    }
  }

  private handleSuccess() {
    this.showMatching = false;
    this.getList();
  }

  private handleMarkSuccess() {
    this.showMarks = false;
    this.getList();
  }

  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.searchForm[0].options = res;
  }

  private async handleAbnormal(row) {
    await markException(row.row.id).then(async res => {
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    }).catch(err => {
      console.log(err);
    });
  }

  private async handleNormal(row) {
    await markNormal(row.row.id).then(async res => {
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    }).catch(err => {
      console.log(err);
    });
  }

  private async getSuppliers(name = "") {
    const res: any = await getSuppliersList({ abbreviation: name });
    return res;
  }

  private async handleInvalidPiNo(row) {
    this.$confirm("确定取消作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await putCancelInvalid(row.row.id);
        this.$notify({
          title: "成功",
          message: "操作成功",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private deliveryCompleted(row) {
    this.$confirm("确定交货完成吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await updatePackingState(row.row.id);
        this.$notify({
          title: "成功",
          message: "操作成功",
          type: "success",
          duration: 2000,
        });
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async getRecordsStatus() {
    const res: any = await getRecordsStatus(this.customerInfo.approvalRecordId);
    this.customerStatus = res.data;
  }

  private async getDraftPriceType() {
    const res: any = await getDraftPriceType();
    res.forEach((item) => {
      item.id = item.name;
      item.name = item.desc;
    });
    let index = this.tableCol.findIndex((item) => {
      return item.key === "unitPriceType";
    });
    this.tableCol[index].typeList = res;
  }

  public querySearch(data) {
    const params = Object.assign({}, data);
    const { time, ...rest } = params;
    if (time && time.length) {
      rest.orderStartTime = time[0];
      rest.orderEndTime = time[1];
    }
    this.listParam = rest;
    this.table.pageNumber = 1;
    this.getList();
  }

  private handleFilter() {
    this.table.pageNumber = 1;
    this.getList();
  }

  public handleCommand(command) {
    this[command]();
  }

  private assignMarkTable = [];

  private handleMarks() {
    this.showMarks = true;
  }

  private async handleInvalidPi(scope) {
    this.$confirm("确定作废吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await invalidPurchaseOrder(scope.row.id)
          .then((res) => {
            this.confirmSuccess();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  // 导出excel
  private isExporting = false;

  // 导出
  public handleExport() {
    if (this.table.list.length === 0) {
      this.$message.warning("页面数据还未查询完毕，请等待。/ 页面无数据，无需下载。");
      return;
    }
    this.isExporting = true;
    let table = this.tableCol.slice(0, this.tableCol.length);
    const headers = table.map((v) => v.label);
    const fieldNames = table.map((v) => v.key);
    let list = deepClone(this.table.list);
    exportJson2Excel(
      headers,
      formatJson(fieldNames, list),
      `下单管理-${new Date()}`
    );
    this.isExporting = false;
  }

  private async getPiInfo() {
    const res: any = await getPiInfo(this.id);
    this.customerInfo = res;
  }

  private handleRemarks() {
    if (!this.selectedRows.length) {
      this.$notify.error("请选择");
      return;
    }
    this.showRemarks = true;
  }

  private async changeRemark() {
    const ids = this.selectedRows.map((item) => {
      return item.id;
    });
    await putRemark({
      remark: this.remark,
      ids,
    })
      .then((res) => {
        this.confirmSuccess();
        this.showRemarks = false;
      })
      .catch((err) => {
        console.log(err);
        this.showRemarks = false;
      });
  }

  // 填写备注
  public async handleRemark(item) {
    try {
      await putRemark({
        remark: item.remark,
        ids: [item.id],
      })
        .then((res) => {
          this.confirmSuccess();
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      await this.getList();
    }
  }
  public async handleRemark2(item) {
    try {
      let data = {
        remark: item.remark
      }
      await poShippingRemark(item.id, data);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    } catch (e) {
      await this.getList();
    }
  }

  public async handleOtherFee(scope) {
    console.log(scope);
    this.currentRow = scope.row;
    this.showOtherFees = true;
  }

  // 查看回执
  public async handleReceipt(scope) {
    this.selectedItem = scope.row;
    this.showReceipt = true;
  }

  private handleHistory(row) {
    console.log('row.row',row.row)
    // this.$router.push({name: "DocumentFlow", params: {type: "CREDIT_NOTICE", documentId: data.row.id}});
  }

  // 上传
  private async handleUpload(val) {
    console.log(val);
    const { file, item } = val;
    let formData = new FormData();
    formData.append("poId", item.id);
    formData.append("receipt", "false");
    formData.append("files", file.file);
    await uploadInfoFile(formData);
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }
  private async handleUploadReceipt(val) {
    console.log(val);
    const { file, item } = val;
    let formData = new FormData();
    formData.append("poId", item.id);
    formData.append("receipt", "true");
    formData.append("files", file.file);
    await uploadInfoFile(formData);
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  private linkClick(scope) {
    this.$router.push(`/orderDetails?id=${scope.row.id}`);
  }

  private confirmSuccess() {
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  private cancelAuditHold() {
    this.$confirm("确定取消挂起吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await auditCancelHold({
          id: this.customerInfo.approvalRecordId,
        });
        this.$notify({
          title: "成功",
          message: "取消成功",
          type: "success",
          duration: 2000,
        });
        this.getRecordsStatus();
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private editAuditHold() {
    this.$prompt("请输入挂起原因", "编辑挂起原因", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputType: "textarea",
    })
      .then(async ({ value }: any) => {
        if (!value) {
          this.$message.error("请输入挂起原因");
          return;
        }
        await auditHold({
          id: this.customerInfo.approvalRecordId,
          remark: value,
        });
        this.$notify({
          title: "成功",
          message: "编辑挂起原因成功",
          type: "success",
          duration: 2000,
        });
        this.getRecordsStatus();
        this.getList();
      })
      .catch(() => {
        // empty
      });
  }

  // 挂起
  private async handleAuditHold() {
    this.$prompt("请输入挂起原因", "挂起", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputType: "textarea",
    })
      .then(async ({ value }: any) => {
        if (!value) {
          this.$message.error("请输入挂起原因");
          return;
        }
        await auditHold({
          id: this.customerInfo.approvalRecordId,
          remark: value,
        });
        this.$notify({
          title: "成功",
          message: "挂起成功",
          type: "success",
          duration: 2000,
        });
        this.getRecordsStatus();
        this.getList();
      })
      .catch(() => {
        // empty
      });
  }

  // 审核通过
  public async handleAuditPass() {
    this.$confirm("确定审核通过吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        await auditPass(this.customerInfo.approvalRecordId);
        this.$notify({
          title: "成功",
          message: "审核通过",
          type: "success",
          duration: 2000,
        });
        this.getRecordsStatus();
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  public async handleDelete(scope) {
    await deleteShippingMarks(scope.row.id);
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 文件管理
  public async handleFile(scope) {
    this.selectedItem = scope.row;
    this.showFile = true;
  }

  // 交货进度
  public async handleDelivery() {
    this.showList = true;
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = false;
    const { total, list }: any = await getPurchaseOrderList(this.id, params);
    list.forEach((item, index) => {
      item.sn =
        (index + 1) * 1 + (this.table.pageNumber - 1) * this.table.pageSize;
      item.completeCode = item.code + (item.suffix ? '-' + item.suffix : '');
    });
    this.table.total = +total;
    this.table.list = list;
    this.table.list.map((item) => {
      if (item.contractualDeliveryDate) {
        item.contractualDeliveryDate = item.contractualDeliveryDate.split(
          " "
        )[0] as any;
      }
    });
    this.loading = false;
    // this.table.list.forEach((item, index) => {
    //   item.shippingMark = item.shippingMark
    //     ? JSON.parse(item.shippingMark).toString()
    //     : null;
    // });
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  // 自动计算
  private async handleCalculate(item) {
    const purchaseDiscount = this.getDiscount(item.purchaseDiscount);
    const purchaseDiscountUnitPrice =
      (1 - purchaseDiscount) * item.purchaseUnitPrice;
    this.$set(item, "purchaseDiscountUnitPrice", purchaseDiscountUnitPrice);
    // 获取采购总价
    const purchaseTotalPrice = purchaseDiscountUnitPrice * item.productQuantity;
    this.$set(item, "purchaseTotalPrice", purchaseTotalPrice);
    // saleDiscount
    const saleDiscount = this.getDiscount(item.saleDiscount);
    // saleUnitPrice
    const saleDiscountUnitPrice = (1 - saleDiscount) * item.saleUnitPrice;
    this.$set(item, "saleDiscountUnitPrice", saleDiscountUnitPrice);
    const saleTotalPrice = item.saleDiscountUnitPrice * item.productQuantity;
    this.$set(item, "saleTotalPrice", saleTotalPrice);
    // 折算利润率
    this.calculateConversionProfitMargin(item);
    this.computedTotalAmount(item);
  }

  private gotoDocumentFlow(data) {
    this.$router.push({name: "DocumentFlow", params: {type: "PURCHASE_ORDER", documentId: data.row.id}});
  }

  /**
   * 折算利润率
   */
  private calculateConversionProfitMargin(item: any) {
    const purchasePrice = item.purchaseTotalPrice;
    const salesRevenue =
      item.saleDiscountUnitPrice *
      item.productQuantity *
      this.conversionExchangeRate;
    if (
      !Number.isFinite(purchasePrice) ||
      !Number.isFinite(salesRevenue) ||
      purchasePrice <= 0
    ) {
      return null;
    }
    const profitRate = (salesRevenue - purchasePrice) / purchasePrice;
    // console.log(profitRate);
    this.$set(item, "conversionProfitMargin", profitRate);
  }

  private getDiscount(val) {
    if (val.indexOf("%") === -1) {
      return val;
    }
    const discountDecimal = parseFloat(val) / 100;
    return discountDecimal;
  }

  // 折算汇率
  private async getConversionExchangeRate() {
    const res: any = await getConversionExchangeRate({});
    this.conversionExchangeRate = +res.conversionExchangeRate;
  }

  // 销售总金额 * 折算汇率 = 销售总金额（人民币）
  // 折算利润额 = 销售总金额（人民币）- 采购总价
  // 计算折算利润额
  private computedTotalAmount(item) {
    let conversionProfitAmount = 0;
    const { saleTotalPrice, purchaseTotalPrice } = item;
    const { conversionExchangeRate } = this;
    conversionProfitAmount =
      conversionExchangeRate * saleTotalPrice - purchaseTotalPrice;
    this.$set(item, "conversionProfitAmount", conversionProfitAmount);
  }

  @Watch("isShowMore")
  private onShowMoreChange() {
    this.$nextTick(() => {
      const table = this.$refs.potable as any;
      if (table && table.doLayout) {
        table.doLayout();
      }
      this.syncFixedHeader();
    });
  }

  // 点击是否展示所有产品号码
  private showMore() {
    this.isShowMore = !this.isShowMore;
  }

  private showMore2() {
    this.isShowMore2 = !this.isShowMore2;
  }

  private showMore3() {
    this.isShowMore3 = !this.isShowMore3;
  }

  private selectedRows: any[] = [];

  private onSelectionChange(rows: any[]) {
    this.selectedRows = rows;
  }

  public async selectChange({val, row, column}) {
    if (column.key === 'brand') {
      await this.updateBrandBySelected(val, row.row.id);
    }
    if (column.key === 'shellPackage') {
      const list = [{
        purchaseOrderId: row.row.id,
        shellPackageInfoId: row.row.shellPackage
      }];
      const data = {purchaseOrderShellPackageReqs: list};
      await savePurchaseOrderShellPackages(data)
          .then(() => this.confirmSuccess())
          .catch(error => console.log(error));
    }
  }

  public async visibleChange(data) {
    if (data.column.key === "shellPackageIds") {
      if (data.val === true) {
        const res = await purchaseOrderMatch({purchaseOrderId: data.row.row.id}) as any;
        data.row.row.shellPackageOption = res.shellPackages;
        this.table.list = deepClone(this.table.list);
      }
    }
  }

  private async findBrandByKeyword(name = "") {
    const data: any = await findBrandByKeyword(this.customerInfo.customerId, name);
    this.brandOptions = data || [];
  }

  private brandTipRoot: HTMLElement | null = null;

  private showBrandTip(event: MouseEvent) {
    const root = event.currentTarget as HTMLElement;
    const cell = root.closest("td");
    if (cell && cell.classList.contains("is-hidden")) return;
    const input = root.querySelector("input") as HTMLInputElement | null;
    const name = input ? input.value.trim() : "";
    if (!input || !name || !this.brandNameHidden(input)) {
      this.hideBrandTip();
      return;
    }
    this.brandTipRoot = root;
    this.brandTipText = name;
    this.$nextTick(() => this.openBrandTip(root));
  }

  private openBrandTip(root: HTMLElement) {
    const tip = this.$refs.brandTip as any;
    if (!tip || this.brandTipRoot !== root) return;
    tip.referenceElm = root;
    if (tip.$refs.popper) tip.$refs.popper.style.display = "none";
    tip.doDestroy();
    tip.setExpectedState(true);
    tip.handleShowPopper();
  }

  private hideBrandTip() {
    this.brandTipRoot = null;
    const tip = this.$refs.brandTip as any;
    if (tip && typeof tip.setExpectedState === "function") {
      tip.setExpectedState(false);
      if (typeof tip.debounceClose === "function") tip.debounceClose();
      else tip.handleClosePopper();
    }
  }

  private onBrandVisible(open: boolean) {
    if (open) this.hideBrandTip();
  }

  private brandNameHidden(input: HTMLInputElement) {
    const style = window.getComputedStyle(input);
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (!context) return input.scrollWidth > input.clientWidth + 1;
    context.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
    const letterSpacing = parseFloat(style.letterSpacing);
    const tracking = Number.isNaN(letterSpacing) ? 0 : letterSpacing * Math.max(input.value.length - 1, 0);
    const padding = (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0);
    return context.measureText(input.value).width + tracking > input.clientWidth - padding + 1;
  }

  private isDeliveryIncomplete(row: any) {
    const entered = parseInt(row.goodsEnteredQuantity);
    const planned = parseInt(row.declarationPlanQuantity);
    const ordered = Number(row.orderQuantity);
    if (!Number.isNaN(entered) && !Number.isNaN(planned) && !Number.isNaN(ordered)) {
      return entered + planned < ordered;
    }
    const parts = String(row.deliveryProgress ?? "").split("/");
    if (parts.length < 2) {
      return false;
    }
    const received = Number(parts[0]);
    const orderedFromText = Number(parts[1]);
    return !Number.isNaN(received) && !Number.isNaN(orderedFromText) && received < orderedFromText;
  }

  private displayCell(value: any) {
    if (value === 0) return 0;
    if (value === "null" || value === "undefined" || value == null) return "";
    return value;
  }

  private sheetValue(item) {
    const value = this.customerInfo[item.key];
    const raw = item.render
      ? item.render(value, this.customerInfo)
      : item.type === "date"
        ? this.formatSheetDate(value)
        : this.displayCell(value);
    return raw === "" || raw == null ? "—" : raw;
  }

  private formatSheetDate(value?: string) {
    if (!value) return "";
    const date = moment(value);
    return date.isValid() ? date.format("YYYY-MM-DD") : value;
  }

  private statText(value: any) {
    const text = this.displayCell(value);
    return text === "" ? "—" : text;
  }

  private priceText(value: any) {
    if (value === "" || value == null || value === "null" || value === "undefined") return "";
    const amount = Number(value);
    if (Number.isNaN(amount)) return this.displayCell(value);
    const formatted = formatPrice(amount);
    if (!formatted) return "";
    const negative = formatted.startsWith("-");
    const unsigned = negative ? formatted.slice(1) : formatted;
    const parts = unsigned.split(".");
    const grouped = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const body = parts.length > 1 ? `${grouped}.${parts[1]}` : grouped;
    return negative ? `-${body}` : body;
  }

  private stateTone(state: string) {
    const tones: Record<string, string> = {
      "待采购确认": "is-confirm",
      "待上传回执": "is-receipt",
      "未交货": "is-undelivered",
      "部分交货": "is-partial",
      "交货已完成": "is-delivered",
      "已核销": "is-written-off",
      "已作废": "is-void",
    };
    return tones[state] || "is-confirm";
  }

  private canSeeAccount(accounts?: string[]) {
    if (!accounts || !accounts.length) return true;
    const userAccounts = UserModule.accountType || [];
    return userAccounts.some((account) => accounts.includes(account));
  }

  private updateTableHeight() {
    this.$nextTick(() => {
      const pane = this.$refs.tablePane as HTMLElement | undefined;
      if (!pane) return;
      const next = Math.floor(pane.clientHeight);
      if (next < 80 || next === this.tableHeight) return;
      this.tableHeight = next;
      this.$nextTick(() => {
        const table = this.$refs.potable as any;
        if (table && table.doLayout) table.doLayout();
        this.syncFixedHeader();
      });
    });
  }

  private onHeaderDragend() {
    window.setTimeout(() => this.syncFixedHeader(), 60);
  }

  private syncFixedHeader() {
    const table = this.$refs.potable as any;
    if (!table || !table.$el) return;
    const mainRow = table.$el.querySelector(".el-table__header-wrapper thead tr") as HTMLElement | null;
    if (!mainRow) return;
    const height = Math.ceil(mainRow.getBoundingClientRect().height);
    const fixedRows = table.$el.querySelectorAll(".el-table__fixed-header-wrapper thead tr");
    fixedRows.forEach((row: HTMLElement) => {
      row.style.height = height + "px";
      const cells = row.querySelectorAll("th");
      cells.forEach((cell: HTMLElement) => {
        cell.style.height = height + "px";
      });
    });
    if (table.layout && typeof table.layout.updateElsHeight === "function") {
      table.layout.updateElsHeight();
    }
  }

  private rowClassName({ row }: { row: any }) {
    if (row.abnormal) return "error-row";
    return "";
  }

  private isBrandDisabled(row) {
    return ["部分交货", "交货已完成", "已核销"].includes(row.orderState);
  }

  private actionAllowed(code: string | string[]) {
    const buttonCodes = (this.$route.meta && (this.$route.meta as any).buttonCodes) || [];
    return checkPermission(code, buttonCodes);
  }

  private canVoid(row) {
    return this.actionAllowed(["cancel"]) && "待采购确认,待上传回执,未交货".indexOf(row.orderState) > -1;
  }

  private canCancelVoid(row) {
    return this.actionAllowed(["deleteCancel"]) && "已作废".indexOf(row.orderState) > -1;
  }

  private canCompleteDelivery(row) {
    if (!row.orderState) return false;
    const stateMatched = String(row.orderState).indexOf("未交货") > -1;
    const packingMatched = row.packingOrAccessories === true;
    return stateMatched && packingMatched;
  }

  private onRowCommand(command: string, row) {
    const handler = this[command];
    if (typeof handler === "function") {
      handler.call(this, { row });
    }
  }

  private openRowRemark(row, prop: string, click: string, length = 255) {
    this.rowRemarkRow = row;
    this.rowRemark = (prop !== "remark" ? row[prop] : row.remark) || "";
    this.rowRemarkClick = click;
    this.rowRemarkLength = length;
    this.showRowRemark = true;
  }

  private confirmRowRemark() {
    const handler = this[this.rowRemarkClick];
    if (typeof handler === "function") {
      handler.call(this, {
        ...this.rowRemarkRow,
        remark: this.rowRemark,
      });
    }
    this.rowRemark = "";
    this.showRowRemark = false;
  }

  private async updateBrandBySelected(selectedBrandId: string, curInfoId: string) {
    try {
    await updatePoBrand(curInfoId, selectedBrandId);
      this.confirmSuccess();
    } catch(error) {
    console.error(error);
    } finally {
     await this.getList();
    }
  }
}
